<template>
  <v-footer app color="teal darken-4" class="footer" height="30">
    <v-layout justify-center row wrap>
      <span v-html="copyrightText"></span>
    </v-layout>
    <span style="float: right; padding-right: 12px;">Version {{ this.$store.getters['status/getApplicationVersion'] }}</span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    copyrightText: function () {
      return 'Copyright &copy; ' + new Date().getFullYear() + ' Nordmann Trade. All rights reserved'
    }
  }
}
</script>

<style scoped>
  .footer {
    min-height: 30px;
    z-index: 1100;
  }
  .footer span {
    color: white;
    font-size: 8pt;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue